module.exports = __webpack_public_path__ + "img/gkrytlxl.4862cbc1.png";